import { Space } from 'component/Space'
import { observer } from 'mobx-react-lite'
import { ProductCard } from 'page/StartScreen/ProductCard'
import { store } from 'store/store'

export const ItemsPane = observer(() => {
  const item = store.item?.json.item_full_image
  const combo = store.comboItem?.json.item_full_image

  return <Space gap={16} tall center columns oh>
    <ProductCard src={item} />
    {combo && <ProductCard src={combo} />}
  </Space>
})
